module.exports = __webpack_public_path__ + "static/media/PM131.7d1ef2f9.png";